import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";
import {
	InputCheckboxMaster,
	InputOptionMaster,
	InputTextMaster,
	LabelRequired,
	MasterButton,
	TableAction,
	TableWrapper,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultToastError, isNull } from "App/utils/helpers";
import {
	headCellsKontak,
	selectTelecomOrganisasi,
	STATE_KONTAK,
} from "../helpers";

export default function OrganisasiKontak({
	formDataKontak,
	setFormDataKontak,
	telecom,
	setTelecom,
}) {
	const handleChange = (text) => (e) => {
		setFormDataKontak({
			...formDataKontak,
			[text]: e.target.value,
		});
	};

	const {
		page,
		setQ,
		setPage,
		setRowsPerPage,
		data,
		order,
		orderBy,
		handleRequestSort,
		length,
		rowsPerPage,
	} = useDatatables({
		rows: telecom,
		orderByDefault: "use",
		orderByRow: ["use"],
		defaultOrder: "asc",
	});

	const handleAddKontak = (e) => {
		e.preventDefault();
		console.log("Hasilnya :", telecom);
		if (isNull(formDataKontak.telecom)) {
			defaultToastError("Harap Pilih Tipe Kontak");
			return false;
		} else if (isNull(formDataKontak.value)) {
			defaultToastError("Harap Isi Input Kontak");
			return false;
		} else {
			const checkTelecom = telecom.filter(
				(x) => x.value === formDataKontak.value
			);
			if (checkTelecom.length > 0) {
				defaultToastError("Data Sudah Ada !, Silahkan ganti inputan kontak");
			} else {
				setTelecom([
					...telecom,
					{
						system: formDataKontak.telecom,
						value: formDataKontak.value,
						use: "work",
					},
				]);
				setFormDataKontak({
					...STATE_KONTAK,
					available: true,
				});
			}
		}
	};

	const handleDeleteKontak = (row) => {
		const dataTelecom = telecom.filter((x) => x.value !== row?.value);
		setTelecom(dataTelecom);
	};

	return (
		<>
			<Paper className="p-1 mb-1">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<h4>KONTAK ORGANISASI</h4>
					<InputCheckboxMaster
						checked={formDataKontak.available}
						name="availableKontak"
						id="availableKontak"
						label="Punya Kontak Organisasi ?"
						onChange={() =>
							setFormDataKontak({
								...formDataKontak,
								available: !formDataKontak.available,
							})
						}
					/>
				</div>

				<form
					onSubmit={(e) => handleAddKontak(e)}
					style={{
						display: formDataKontak.available === false ? "none" : "",
					}}
				>
					<div className="mb-1">
						<Grid container spacing={1}>
							<Grid item md={4}>
								<InputOptionMaster
									name="telecom"
									label={<LabelRequired label="Tipe Kontak" />}
									id="telecom"
									withSearch={false}
									data={selectTelecomOrganisasi}
									value={formDataKontak.telecom}
									needParse={false}
									onChange={handleChange("telecom")}
								/>
							</Grid>
							<Grid item md={4}>
								<InputTextMaster
									name="value"
									label={<LabelRequired label="Input Kontak" />}
									id="value"
									placeholder="Input Kontak"
									value={formDataKontak.value}
									onChange={handleChange("value")}
								/>
							</Grid>
							<Grid item md={4} style={{ paddingTop: "31px" }}>
								<MasterButton
									outline={false}
									type={"submit"}
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "center",
									}}
									color="green"
									name={"TAMBAH"}
									size="md"
								/>
							</Grid>
						</Grid>
					</div>
					<div
						style={{
							marginLeft: "6px",
						}}
					>
						<Grid item md={12}>
							<TableWrapper
								title="Daftar Kontak Yang Terdaftar"
								setQ={setQ}
								withAddButton={false}
								withExportButton={false}
								order={order}
								orderBy={orderBy}
								handleRequestSort={handleRequestSort}
								length={length}
								rows={telecom}
								headCells={headCellsKontak}
								page={page}
								setPage={setPage}
								rowsPerPage={rowsPerPage}
								setRowsPerPage={setRowsPerPage}
							>
								{stableSort(data, getComparator(order, orderBy))
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row, index) => {
										return (
											<TableRow
												hover
												tabIndex={-1}
												key={index}
												style={{
													backgroundColor:
														index % 2 === 0 ? "transparent" : "#fff",
												}}
											>
												<TableCell
													component="th"
													scope="row"
													padding="none"
													width="5%"
													align="center"
												>
													{index + 1}
												</TableCell>
												<TableCell align="center">
													<TableAction
														clickDelete={() => handleDeleteKontak(row)}
														isUpdate={false}
													/>
												</TableCell>
												<TableCell align="left">
													{isNull(row?.system) ? "-" : row?.system}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.value) ? "-" : row?.value}
												</TableCell>
											</TableRow>
										);
									})}
							</TableWrapper>
						</Grid>
					</div>
				</form>
			</Paper>
		</>
	);
}
